import { useState } from 'react'
import { Box, MenuItem, Select, Typography } from '@mui/material'
import { i18n } from '@lingui/core'

export const LanguageSwitcher = () => {
  const langs = [
    {
      flag: "https://flagcdn.com/gb.svg"
      , label: "English"
      , value: 'en'
    }
    , {
      flag: "https://flagcdn.com/es.svg"
      , label: "Español"
      , value: 'es'
    }
    , {
      flag: "https://flagcdn.com/fr.svg"
      , label: "Français"
      , value: 'fr'
    }
    , {
      flag: "https://flagcdn.com/pt.svg"
      , label: "Português"
      , value: 'pt'
    }
  ]

  const [lang, setLang] = useState(localStorage.getItem('preferredLanguage') || 'fr')

  const changeLanguage = lng => {
    setLang(lng) 
    i18n.activate(lng)
    localStorage.setItem('preferredLanguage', lng)
  }

  return (
    <Box position='absolute' top={0} right={0} mt={1} mr={1}>
      <Select
        value={lang}
        onChange={e => changeLanguage(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          backgroundColor: 'transparent',
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: 'transparent',
              '& .MuiMenuItem-root': {
                bgcolor: 'transparent',
              },
              '& .MuiMenuItem-root:hover': {
                // backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backgroundColor: 'transparent',
              }
            }
          }
        }}
      >
        {langs.map(lang => (
          <MenuItem key={lang.value} value={lang.value}>
            {/* <Box display='flex'> */}
              <Box
                height='1.5rem'
                border='1px solid #c4c4c4'
                borderRadius={1}
                sx={{
                  aspectRatio        : '4/3'
                  , backgroundImage    : `url('${lang.flag}')`
                  , backgroundSize     : 'cover'
                  , backgroundPosition : 'center center'
                }}
              />
              {/* <Typography ml={3}>{lang.label}</Typography> */}
            {/* </Box> */}
          </MenuItem>
          ))
        }
      </Select>
    </Box>
  )
}